import { HttpClient, JSON_STRING } from "../../../../services/http/http-client";
import { BOOKING_URL, BOOKINGS_STRING, CALENDAR_DATE_ID, TRAVEL_URL } from "../booking-service";
import { MODIFICATION_URL } from "../../../../services/common-urls";

const CALENDAR_BOOKINGS_LOCAL_DETAILS = 'calendar_bookings_local_details';
const LOCAL_INFO = 'local_info';
const CALENDAR_DATES = 'calendar_dates';
const LOCAL_DETAILS_CONFIRMED_FLAG = 'local_details_confirmed_flag';
const REMOVE_COTNACT_RELATION = 'remove_contact_relations_n_calendar_date_locals';
const GET_API_EAN_HOTEL_LIST_BY_GIVEN_DATA = 'get_api_ean_hotel_list_by_given_data';
const SHOW_PROMOTER_DEFAULT_NEW = 'show_promoter_default_new';
const SAVE_PROMOTER_DEFAULT_LOCAL_DETAIL = 'save_promoter_default_local_detail';
const MODAL_LOCAL_DETAILS = 'modal_local_details';

const GET_GOOGLE_PLACES_API_HOTEL_LIST = 'get_google_places_api_hotel_list';
const GET_GOOGLE_PLACES_API_HOTEL_DETAILS = 'get_google_places_api_hotel_details';
const LOCAL_DETAILS_NAME_AUTOCOMPLETE_JSON = 'local_details_name_autocomplete_json';
const ADD_NEW_LOCAL_DETAILS = 'add_new_local_detail';
const MODIFY_STRING = 'modify';
const RECORD_STRING = 'record';
const LOCAL_DETAILS_STRING = 'local_details';
const ADD_REMOVE_LOCAL_DETAILS_CONTACT = 'add_remove_local_details_contacts';
const CUSTOM_DATA_STRING = 'custom_data';

export const localDetailsService = {
  findLocalDetails: ({
    calendarDateId,
    options
  }) => HttpClient.post(BOOKING_URL, {
    section: BOOKINGS_STRING,
    action: CALENDAR_BOOKINGS_LOCAL_DETAILS,
    calendar_date_id: calendarDateId,
    output: JSON_STRING
  }, options),
  updateLocalInfo: (
    calendarDateId,
    value
  ) => HttpClient.modify(
    CALENDAR_DATE_ID,
    calendarDateId,
    LOCAL_INFO,
    value,
    CALENDAR_DATES
  ),
  updateLocalDetailsConfirmationFlag: (
    calendarDateId,
    value
  ) => HttpClient.modify(
    CALENDAR_DATE_ID,
    calendarDateId,
    LOCAL_DETAILS_CONFIRMED_FLAG,
    value,
    CALENDAR_DATES
  ),
  removeCalendarDateLocal: (
    localDetailId
  ) => HttpClient.get2( BOOKING_URL, {
    section: BOOKINGS_STRING,
    action: REMOVE_COTNACT_RELATION,
    local_detail_id: localDetailId
  }),
  findHotelMail: (
    calendarDateId,
    localDetailId,
    name = '',
    address1 = '',
    city = '',
    postalcode = '',
    country = '',
  ) => HttpClient.post( TRAVEL_URL, {
    calendar_date_id: calendarDateId,
    local_detail_id: localDetailId,
    name,
    address1,
    city,
    postalcode,
    country,
    section: BOOKINGS_STRING,
    action: GET_API_EAN_HOTEL_LIST_BY_GIVEN_DATA
  }),
  showPromoterDefaultNew: (
    calendarDateId
  ) => HttpClient.get(BOOKING_URL, {
    section: BOOKINGS_STRING,
    action: SHOW_PROMOTER_DEFAULT_NEW,
    calendar_date_id: calendarDateId
  }),
  savePromoterDefault: (
    calendarDateId,
    fromCalendarDateId
  ) => {
    return HttpClient.post( BOOKING_URL, {
      section: BOOKINGS_STRING,
      action: SAVE_PROMOTER_DEFAULT_LOCAL_DETAIL,
      calendar_date_id: calendarDateId,
      from_calendar_date_id: fromCalendarDateId,
      dataType: JSON_STRING
    })
  },

  // https://staging.detailsdetails.eu/berlin3/booking.pl?
  // section=bookings&
  // action=modal_local_details&
  // calendar_date_id=3450&
  // output=json

  findRelationTypes: (
    calendarDateId
  ) => HttpClient.get(BOOKING_URL, {
    section         : BOOKINGS_STRING,
    action          : MODAL_LOCAL_DETAILS,
    calendar_date_id: calendarDateId,
  }),
  findLocalDetailsForm: (
    localDetailsTypeId,
    calendarDateId,
    showLocalDetailsElements = 1
  ) => HttpClient.post(BOOKING_URL, {
    section: BOOKINGS_STRING,
    action: MODAL_LOCAL_DETAILS,
    local_details_type_id: localDetailsTypeId,
    calendar_date_id: calendarDateId,
    show_local_details_elements: showLocalDetailsElements,
    output: JSON_STRING
  }),

  // Get Hotel List
  findGooglePlaces: ({
    calendarDateId,
    term,
    searchTypeParam
  }) => HttpClient.post(TRAVEL_URL, {
    section: BOOKINGS_STRING,
    action: GET_GOOGLE_PLACES_API_HOTEL_LIST,
    calendar_date_id: calendarDateId,
    term: term,
    searchTypeParam
  }),
  // Find Local Details name autocomplete
  findLocalDetailsName: ({
    term,
    calendarDateId
  }) => HttpClient.post(BOOKING_URL, {
    section: BOOKINGS_STRING,
    action: LOCAL_DETAILS_NAME_AUTOCOMPLETE_JSON,
    term: term,
    calendar_date_id: calendarDateId,
  }),
  // Find Hotel Details
  findHotelDetails: ({
    calendarDateId,
    placeId
  }) => HttpClient.post(TRAVEL_URL, {
    section: BOOKINGS_STRING,
    action: GET_GOOGLE_PLACES_API_HOTEL_DETAILS,
    calendar_date_id: calendarDateId,
    place_id: placeId,
  }),

  // Add New Local Details
  addNewLocalDetails: ({
    localDetailsTypeId,
    calendarDateId,
  }) => HttpClient.post(BOOKING_URL, {
    section: BOOKINGS_STRING,
    action: ADD_NEW_LOCAL_DETAILS,
    local_details_type_id: localDetailsTypeId,
    calendar_date_id: calendarDateId,
    dataType: JSON_STRING
  }),
  // Local Details Modfication Record
  addLocalDetailsRecord: ({
    localDetailsId,
    localDetailsFormData
  }) => HttpClient.post(MODIFICATION_URL, {
    action: MODIFY_STRING,
    modify_type: RECORD_STRING,
    table: LOCAL_DETAILS_STRING,
    kVal: localDetailsId,
    ...localDetailsFormData
  }),
  // Add Remove Local Details Contact
  addRemoveLocalDetailsContact: ({
    data,
    kVal,
    localDetailsId,
    contacts
  }) => HttpClient.post(BOOKING_URL, {
    action: ADD_REMOVE_LOCAL_DETAILS_CONTACT,
    modify_type: RECORD_STRING,
    table: CUSTOM_DATA_STRING,
    data,
    kVal,
    section: BOOKINGS_STRING,
    external_id: localDetailsId,
    contacts
  }),
  // https://staging.detailsdetails.eu/berlin3/booking.pl?
  // section=bookings&
  // action=modal_local_details&
  // calendar_date_id=3596&
  // local_detail_id=186764&
  // rndval=1543842726676
  // Get Local Details Description
  findLocalDetailsMore: ({
    calendarDateId,
    localDetailsId
  }) => HttpClient.get(BOOKING_URL, {
    section: BOOKINGS_STRING,
    action: MODAL_LOCAL_DETAILS,
    calendar_date_id: calendarDateId,
    local_detail_id: localDetailsId
  })
};
